'use client'

import Footer from "./Footer"
import Header from "./Header"
import { useState } from "react"
import { usePathname } from "next/navigation"
import { canShowCustomerChat, getFontClass, isAuthRoute } from "@/utils/util"
import MobileBottomNav from "./MobileBottomNav"
import { useVisitTracking } from "@/lib/commerce/hooks"
import CustomerChat from "../customer-chat/CustomerChat"
import RewardVariantModal from "../cart/RewardVariantModal"

export default function Layout({ children, vendor, categories, customer, subscription, campaigns }: { children: React.ReactNode, vendor: any, categories: any, customer: any, subscription?: any, campaigns?: any }) {
  const pathname = usePathname()
  const fontClass = getFontClass(vendor?.font)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  useVisitTracking(vendor)

  if (isAuthRoute(pathname)) {
    return (
      <div className={fontClass}>
        {children}
      </div>
    )
  }

  return (
    <div>
      <Header vendor={vendor} categories={categories} subscription={subscription} campaigns={campaigns} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <div className={`min-h-[calc(100vh-88px)] ${fontClass}`}>
        {children}
      </div>
      <Footer vendor={vendor} subscription={subscription} />
      {canShowCustomerChat(vendor, subscription) && <CustomerChat vendor={vendor} />}
      <MobileBottomNav vendor={vendor} customer={customer} subscription={subscription} setMobileMenuOpen={setMobileMenuOpen} />
      <RewardVariantModal vendor={vendor} />
    </div>
  )
}
